<template>
  <div>
    <Header></Header>
    <ContentBg></ContentBg>
    <Buy></Buy>
    <ShowOrder></ShowOrder>
    <Lottery></Lottery>
    <Partner></Partner>
    <LotteryWindowOne></LotteryWindowOne>
    <LotteryWindowTwo></LotteryWindowTwo>
    <LotteryWindowThree></LotteryWindowThree>
    <LotteryList></LotteryList>
    <Nav></Nav>
    <Login></Login>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/blocks/Header';
import ContentBg from '@/blocks/ContentBg';
import Buy from '@/blocks/Buy';
import ShowOrder from '@/blocks/ShowOrder';
import Lottery from '@/blocks/Lottery';
import Partner from '@/blocks/Partner';
import Footer from '@/blocks/Footer';
import Nav from '@/blocks/Nav';
import LotteryWindowOne from '@/blocks/LotteryWindowOne';
import LotteryWindowTwo from '@/blocks/LotteryWindowTwo';
import LotteryWindowThree from '@/blocks/LotteryWindowThree';
import LotteryList from '@/blocks/LotteryList';
import Login from '@/blocks/Login';
export default {
  components: {
    Header,
    ContentBg,
    Buy,
    ShowOrder,
    Lottery,
    Partner,
    Footer,
    Nav,
    LotteryWindowOne,
    LotteryWindowTwo,
    LotteryWindowThree,
    LotteryList,
    Login,
  },
  mounted () {
    this.$http.blockContent({actId:543}).then((res) => {
      // console.log(res);
      let BlockTitle = [];
      BlockTitle.push(res.data.shoppingGuide.title, res.data.shareOrder.title, res.data.dayDrawLottery.title);
      this.$bus.emit('blockTitleData', BlockTitle);
      this.$bus.emit('indexBgData', res.data.mainView);
      this.$bus.emit('buyData', res.data.shoppingGuide);
      this.$bus.emit('showOrderData', res.data.shareOrder);
      this.$bus.emit('partnerData', res.data.partner);
      this.$bus.emit('lotteryCalendarData', res.data.weekDrawLottery);
      this.$bus.emit('dayDrawLotteryData', res.data.dayDrawLottery);
    });
    this.$http.actStatus({actCode: this.$str('actCode')}).then((res) => {
      if(res.data.activityStatus === 'live'){
        localStorage.setItem('isLive', true);
        localStorage.setItem('isWait', false);
        localStorage.setItem('isEnd', false);
      } else if(res.data.activityStatus === 'wait') {
        localStorage.setItem('isWait', true);
        localStorage.setItem('isLive', false);
        localStorage.setItem('isEnd', false);
      } else if(res.data.activityStatus === 'end') {
        localStorage.setItem('isEnd', true);
        localStorage.setItem('isLive', false);
        localStorage.setItem('isWait', false);
      }
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/index.vue